import React, {PureComponent} from "react";
import {motion} from "framer-motion";
import BGGraphic7 from "../../img/graphics/BGGraphic7";

class YourGoodNetworkSection extends PureComponent {
    render() {
        return (
            <section className={this.props.mobile ? 'col-ac relative' : 'row-ac-jb relative'}
                     style={{
                         padding: this.props.mobile ? '80px 24px' : '80px 10vw',
                         background: this.props.mobile
                             ? 'linear-gradient(180deg, rgba(245,248,255,0.9) 0%, rgba(255,255,255,1) 100%)'
                             : 'linear-gradient(90deg, rgba(245,248,255,1) 0%, rgba(255,255,255,1) 100%)'
                     }}>
                <BGGraphic7 className='absolute' fill={'#F0A042'}
                            style={{
                                top: this.props.mobile ? 24 : 60,
                                right: this.props.mobile ? -20 : 80,
                                width: this.props.mobile ? '22vw' : '10vw',
                                opacity: .16
                            }}/>
                <motion.div style={{flex: 1, maxWidth: !this.props.mobile && '32vw'}}
                            initial={{opacity: 0, transform: 'scale(1) translateY(12px)'}}
                            whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}
                            transition={{default: {ease: "linear"}, delay: .1}}
                            className={this.props.mobile ? 'mb-32 col-plain' : 'col-plain'}>
                    <div className='body3-bold black-50 mb-8' style={{textTransform: 'uppercase'}}>
                        COMMUNITY
                    </div>
                    <h1 className='heading2 black-100 mb-24 mt-0'>
                        Your Good Network
                    </h1>
                    <p className='mt-0 body1 black-70'>
                        Your Good Network is a living circle of people, causes, and communities that reflect what inspires you and what you stand for. Your Good Network is unique to you, shaped by the Good you support and the bonds you make along your way.
                    </p>
                    <p className='mt-0 body1 black-70'>
                        Your Good Network grows as big as you want…just keep inviting and connecting with those people and organizations you see making a positive impact. Everyone is welcome on Starfish because Good has no boundaries.
                    </p>
                </motion.div>
                <motion.div style={{flex: 1, maxWidth: this.props.mobile ? '100%' : '42vw'}}
                            initial={{opacity: 0, transform: 'scale(1) translateY(12px)'}}
                            whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}
                            transition={{default: {ease: "linear"}, delay: .2}}
                            className='col-plain'>
                    <div className={this.props.mobile ? 'p-5 br-24' : 'p-12 br-24'}
                         style={{
                             backgroundColor: '#054A91',
                             boxShadow: '0 24px 60px rgba(5, 74, 145, 0.14)',
                             color: '#FFFFFF'
                         }}>
                        <div className='heading4 mb-20' style={{color: '#FFFFFF', lineHeight: 1.35}}>
                            Good connects us.<br/>
                            Good unites us.<br/>
                            Good is rewarded in the marketplace.
                        </div>
                        <p className='mt-0 body1 mb-20' style={{color: '#FFFFFF', opacity: .92}}>
                            Everyone is welcome on Starfish because Good has no boundaries.
                        </p>
                        <div className='row-ac' style={{flexWrap: 'wrap', gap: 12}}>
                            <div className='body2-bold ph-20 pv-12 br-64'
                                 style={{backgroundColor: 'rgba(255,255,255,0.14)', color: '#FFFFFF'}}>
                                #BeTheGood
                            </div>
                            <div className='body2-bold ph-20 pv-12 br-64'
                                 style={{backgroundColor: 'rgba(255,255,255,0.14)', color: '#FFFFFF'}}>
                                #SeeTheGood
                            </div>
                            <div className='body2-bold ph-20 pv-12 br-64'
                                 style={{backgroundColor: 'rgba(240,160,66,0.22)', color: '#FFFFFF'}}>
                                #ShareTheGood
                            </div>
                        </div>
                    </div>
                </motion.div>
            </section>
        )
    }
}

export default YourGoodNetworkSection;
